<div id="pageContainer" class=" container pages_tabs">
  <div id="pageHeading" class="heading">{{publishedName}} - <span i18n="@@page.content.page-name">PAGE
      {{pageNumber}}</span></div>
  <div id="pageContainerFluid" class="container-fluid">
    <form *ngIf="pageGrpForm">
      <div id="pageRow" class="row">
        <div id="pageCol" class="col-xl-2 col-sm-3" id="themeColumn"
            [ngClass]="(pageGrpForm.fullScreenCheckbox && pageGrpForm.media.format === 'video/mp4') ? 'disablecolorFields' : ''">
          <!-- [ngClass]="((pageGrpForm.previewType !== globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS)||
          (pageGrpForm.previewType === globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS && pageGrpForm.fullScreenCheckbox
          && pageGrpForm.media.format === 'video/mp4')) ? 'disablecolorFields' : ''"> -->
          <div id="pageFormGrp" class="form-group">
            <label for="" i18n="@@page.content.theme">Theme</label>
            <div id="themePickerBtn" class="theme_picker_button default" (click)="openColPicModal()">
              <span class="text_color" [style.background-color]="pageGrpForm.bcolor"></span>
              <span class="bg_color" [style.background-color]="pageGrpForm.bgcolor"></span>
            </div>
          </div>
          <div id="pageBGColor" class="form-group">
            <label for="" class="bg_color_text_width" i18n="@@page.content.bg-color">Background color</label>
            <!-- <div class="color_picker_button default"></div> -->
            <input readonly [(colorPicker)]="pageGrpForm.bgcolor"
              [cpPosition]="changePlacement == true ? 'left' : 'right'" [style.background]="pageGrpForm.bgcolor"
              class="color_picker_button" name="bgcolor" (colorPickerChange)="emitPageDataToPreview()" />
          </div>
        </div>
        <div id="pageGrpFormCol" class="col-xl-10 col-sm-9">
          <div id="pageGrpFormContainer" class="container-fluid">
            <div id="pageGrpFormRow" class="row">
              <div id="pageGrpFormSubRow" class="col-xl-8">
                <div id="pageGrpFormRow" class="form-row">
                  <div id="formGrp" class="form-group col-10">
                    <label for="">{{headingLabel}}</label><span class="formfield_limit_msg"
                      i18n="@@page.content.heading-max-50-chars">(Max 50 characters)</span>
                    <input type="text" class="form-control" id="" placeholder={{headingPlaceHolderText}}
                      [(ngModel)]="pageGrpForm.heading" name="heading" (keyup)="emitPageDataToPreview()" maxlength="50"
                      [disabled]="disableInVideoMode" />
                    <div id="errMsg" class="formfield_err_msg" *ngIf="pageGrpForm.heading.length>50">
                      <span i18n="@@page.content.heading-cannot-be-more-than-50">Heading cannot be more than 50
                        characters.</span>
                    </div>
                  </div>
                  <div id="hColor" class="form-group col-2 color-container">
                    <label for="" i18n="@@page.content.color">Color</label>
                    <input readonly [(colorPicker)]="pageGrpForm.hcolor" [cpPosition]="'right'"
                      [style.background]="pageGrpForm.hcolor" class="color_picker_button" name="hcolor"
                      (colorPickerChange)="emitPageDataToPreview()"
                      [ngClass]="(pageGrpForm.fullScreenCheckbox && pageGrpForm.media.format === 'video/mp4') ? 'disablecolorFields' : ''"/>
                      <!-- [ngClass]="((pageGrpForm.previewType !== globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS)||
                      (pageGrpForm.previewType === globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS && pageGrpForm.fullScreenCheckbox
                      && pageGrpForm.media.format === 'video/mp4')) ? 'disablecolorFields' : ''" /> -->
                  </div>
                </div>
                <div id="bodyLabel" class="form-row">
                  <div class="form-group col-10">
                    <label for="">{{bodyLabel}}</label><span class="formfield_limit_msg"
                      i18n="@@page.content.body-max-250-chars">(Max 250 characters)</span>
                    <!-- <textarea
                            class="form-control"
                            id=""
                            rows="3"
                            placeholder={{bodyPlaceHolderText}}
                            [(ngModel)]="pageGrpForm.body"
                            name="body"
                            (keyup)="emitPageDataToPreview()"
                            maxlength="250"
                          ></textarea> -->
                    <ckeditor [disabled]="disableInVideoMode" [editor]="Editor" [(ngModel)]="pageGrpForm.body"
                      [ngModelOptions]="{standalone: true}" (change)="onChange($event)" (ready)="onReady($event)">
                    </ckeditor>
                    <div class="standDiv">
                      <span class="formfield_err_msg" *ngIf="isBodyTextError"
                        i18n="@@page.content.body-cannot-be-more-than-250">Body Text cannot be more than 250
                        characters.</span>
                    </div>
                  </div>

                </div>
              </div>
              <div id="popOver" class="col-xl-4">
                <div class="form-group">
                  <ng-template #popContent>
                    <div id="popOverUpload" class="popover-upload-req">
                      <div id="imgVideoSizeInfo" class="d-flex align-items-center">
                        <img src="assets/images/image-icon.png" alt="image" />
                        <ul [ngClass]="isImgVideoSizeInfoEnabled ? 'tooltip-list-style' : ''">
                          <li i18n="@@global.tooltip.image-rule-format">Images must be in <strong>JPG, PNG, JPEG,
                              JFIF</strong> or <strong>GIF</strong> format</li>
                          <li *ngIf="!isImgVideoSizeInfoEnabled"><span
                              i18n="@@global.tooltip.image-max-size-error">Allowed maximum size is <strong>5
                                MB</strong></span></li>
                                <li [innerHTML] = aspectRatioText></li>
                        </ul>
                      </div>
                      <hr />
                      <div id="ImgVideoSizeInfoEnabled" class="d-flex align-items-center">
                        <img src="assets/images/video-icon.png" alt="video" />
                        <ul [ngClass]="isImgVideoSizeInfoEnabled ? 'tooltip-list-style' : ''">
                          <li i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong> format
                          </li>
                          <li *ngIf="!isImgVideoSizeInfoEnabled" i18n="@@global.tooltip.video-rule-length">Allowed
                            maximum length is <strong>60 seconds</strong></li>
                          <li *ngIf="!isImgVideoSizeInfoEnabled" i18n="@@global.tooltip.video-max-size-error">Allowed
                            maximum size is <strong>10 MB</strong></li>
                        </ul>
                      </div>
                    </div>
                  </ng-template>
                  <label for="">
                    <span i18n="@@page.content.image-video">Image/Video</span>
                    <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for help"
                      [placement]="changePlacement == true ? 'right' : 'left'" [ngbPopover]="popContent"
                      container="body" triggers="mouseenter:mouseleave" />
                  </label><br />
                  <!-- <span  class="formfield_limit_msg"> (Max image size - 5 MB/ Max Video size - 10 MB) </span> -->
                  <label>
                    <input #file id="uploadLogo" type="file"
                      accept="video/mp4,image/jpg,image/jfif,image/x-png,image/jpeg,image/gif"
                      (change)="processFile(file.files)">
                    <video #video style="display: none;" *ngIf="videoUrl" controls src="{{videoUrl}}"
                      (loadedmetadata)="getVideoDuration($event)">
                    </video>
                    <span class="btn btn-primary left_icon_btn gtmUploadImgVideo">
                      <img src="assets/images/image_icon.svg" alt="upload image" />
                      <span i18n="@@page.content.upload-image-video">Upload Image/Video</span>
                    </span>
                  </label>
                  <div id="pageGrpFormMedia" *ngIf="pageGrpForm.media.name && !(isUploadError)"
                    class="uploadfilename_container">{{pageGrpForm.media.name}}</div>
                    <!--For IIT2-16343 & IIT2-17424 -->
                    <div id="showFullScreen" class="fullScreenCheckbox-container">
                      <input type="checkbox" [checked]="pageGrpForm.fullScreenCheckbox"
                        [ngModelOptions]="{standalone: true}" [(ngModel)]="pageGrpForm.fullScreenCheckbox" value=""
                        id="showImageVideoFullscreen" name="showImageVideoFullscreen" (ngModelChange)="onNgModelChangCheck()" />
                      <label class="form-check-label" for="showImageVideoFullscreen">
                        <span i18n="@@page-component.label.fullScreenCheckbox-text">Show image/video in full screen</span>
                      </label>
                    </div>
                  <div id="fullScreenIdleExperienceCheckBox" class="fullScreenCheckbox-container"
                    [ngClass]="pageGrpForm.previewType === globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS ? 'hideullScreenIdleExperienceCheckBox' : ''"
                    *ngIf="contentGroupType === 'Segments' || contentGroupType === 'PromoContentGroup' || contentGroupType === 'LogoContentGroup'">
                    <input type="checkbox"
                      [ngClass]="pageGrpForm.previewType === globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS || pageGrpForm.media.url === '' ? 'uncheckCheckbox' : ''"
                      [disabled]="pageGrpForm.previewType === globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS || pageGrpForm.media.url === ''"
                      id="fullScreenImageVideo" [(ngModel)]="pageGrpForm.idleExpFullscreenEnabled"
                      [ngModelOptions]="{standalone: true}" (ngModelChange)="onNgModelChangCheck()" />
                    <label class="form-check-label" for="fullScreenImageVideo">
                      <div id="fullScreenTitleText" class="title">{{globConst.PAGE_CONTENT_FULLSCREEN_DESC}}</div>
                    </label>
                  </div>
                  <div class="fullScreenNotes-container" *ngIf="disableInVideoMode && pageGrpForm.previewType === globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE">
                    <p><strong>Note: </strong>{{globConst.PAGE_CONTENT_FULLSCREEN_NOTE}}</p>
                  </div>
                  <div class="fullScreenNotes-container" *ngIf="disableInVideoMode && pageGrpForm.previewType === globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS">
                    <p><strong>Note: </strong>{{globConst.PAGE_CONTENT_FULLSCREEN_NOTE_IPOS_PREVIEW}}</p>
                  </div>
                  <div id="videoTypeError" *ngIf="isVideoTypeError || isImageTypeError"
                    class="uploadfile_err_msg file_type_error_width"><span
                      i18n="@@page.content.image-video-file-type-error">Incorrect file type received. Image must be in
                      <strong>JPG, PNG,</strong> or <strong>GIF</strong> format.
                      Video must be in <strong>MP4</strong> format.</span></div>
                  <div id="imageSizeError" *ngIf="isImageSizeError" class="uploadfile_err_msg image_size_error_width">
                    <span i18n="@@global.content-grp.image-max-size-error">File exceeds maximum size <strong>(5
                        MB).</strong></span></div>
                  <div id="videoSizeError" *ngIf="isVideoSizeError" class="uploadfile_err_msg video_size_error_width">
                    <span i18n="@@global.content-grp.video-size-error">Video exceeds maximum size of <strong>10
                        MB.</strong></span></div>
                  <div id="VideoDurationError" *ngIf="isVideoDurationError"
                    class="uploadfile_err_msg video_length_error_width"><span
                      i18n="@@global.content-grp.video-duration-error">Video must be <strong>less than 60 seconds
                        long.</strong></span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<ng-template #colorpicker>
  <div id="colorPickerCard" class="card" dir={{direction}}>
    <div id="colorPickerBody" class="popup-body">
      <div id="colorPickerHeader" class="modal-header p-0">
        <div id="colorPickerClose" (click)="dismiss()" class="close_icon popup_close">
          <img src="assets/images/popup_close_button.svg" alt="color picker" class="cursor-pointer" />
        </div>
      </div>
      <div id="colorPickerModalBody" class="modal-body p-0">
        <div id="themePick" class="card">
          <div id="themePickHeader" class="theme_pick_header" [style.background-color]="pageGrpForm.bgcolor">
            <div id="themePickTitle" class="theme_pick_title" [style.color]="pageGrpForm.hcolor">{{pageGrpForm.heading
              === ''? headingLabel:pageGrpForm.heading}}</div>
            <div id="themePickSubTitle" class="theme_pick_subtitle"
              [innerHTML]="(pageGrpForm.body === ''? bodyLabel:pageGrpForm.body) | htmlSanitizer"
              [ngStyle]="{'color':pageGrpForm.bcolor,'font-size':fontSize(pageGrpForm.size)}"></div>
          </div>
          <div id="themePickText" class="theme_pick_text">
            <span style="font-weight: bold;" i18n="@@page.theme-picker.optional">Optional</span>:
            <span i18n="@@page.theme-picker.ensure-accessibility-text">Ensure accessibility by choosing from WCAG 2.0
              AA-compliant themes.</span>
          </div>
          <div id="themeColoBblue" class="theme_color mb-3">
            <div id="themeBlueWrapper" class="theme-wrapper">
              <div id="themePickerBlueBtn" class="theme_picker_button default"
                (click)="chooseTheme('#ffffff','#0068B5')">
                <span class="text_color" [ngClass]="{'text_color_white':invert,'bg_color_blue_shade':!invert}"></span>
                <span class="bg_color" [ngClass]="{'text_color_white':!invert,'bg_color_blue_shade':invert}"></span>
              </div>
              <span
                [ngClass]="{'color_highlighter': isSelected('#ffffff','#0068B5' ) || isSelected('#0068B5','#ffffff' ) }"></span>
            </div>
            <div id="themeRedWrapper" class="theme-wrapper">
              <div id="themePickerRedBtn" class="theme_picker_button default"
                (click)="chooseTheme('#ffffff','#C81326')">
                <span class="text_color" [ngClass]="{'text_color_white':invert,'bg_color_red':!invert}"></span>
                <span class="bg_color" [ngClass]="{'text_color_white':!invert,'bg_color_red':invert}"></span>
              </div>
              <span
                [ngClass]="{'color_highlighter': isSelected('#ffffff','#C81326') || isSelected('#C81326','#ffffff')}"></span>
            </div>
            <div id="themeMaroonWrapper" class="theme-wrapper">
              <div id="themePickerMarronBtn" class="theme_picker_button default"
                (click)="chooseTheme('#ffffff','#653171')">
                <span class="text_color" [ngClass]="{'text_color_white':invert,'bg_color_maroon':!invert}"></span>
                <span class="bg_color" [ngClass]="{'text_color_white':!invert,'bg_color_maroon':invert}"></span>
              </div>
              <span
                [ngClass]="{'color_highlighter': isSelected('#ffffff','#653171') || isSelected('#653171','#ffffff')}"></span>
            </div>
            <div id="themeYellowWrapper" class="theme-wrapper">
              <div id="themePickerYellowBtn" class="theme_picker_button default"
                (click)="chooseTheme('#F6CB4B','#1E2EB8')">
                <span class=" text_color"
                  [ngClass]="{'text_color_yellow':invert,'bg_color_blue_shadee':!invert}"></span>
                <span class="bg_color" [ngClass]="{'text_color_yellow':!invert,'bg_color_blue_shadee':invert}"></span>
              </div>
              <span
                [ngClass]="{'color_highlighter': isSelected('#F6CB4B','#1E2EB8') || isSelected('#1E2EB8','#F6CB4B')}"></span>
            </div>
            <div id="themeGreyWrapper" class="theme-wrapper">
              <div id="themePickerGreyBtn" class="theme_picker_button default" style="margin-right:0"
                (click)="chooseTheme('#000964','#AEAEAE')">
                <span class="text_color" [ngClass]="{'text_color_dark_blue':invert,'bg_color_grey':!invert}"></span>
                <span class="bg_color" [ngClass]="{'text_color_dark_blue':!invert,'bg_color_grey':invert}"></span>
              </div>
              <span
                [ngClass]="{'color_highlighter': isSelected('#000964','#AEAEAE') || isSelected('#AEAEAE','#000964')}"></span>
            </div>
          </div>
          <div id="themeBlackWrapper" class="theme_color">
            <div id="themePickerBlackBtn" class="theme-wrapper">
              <div class="theme_picker_button default" style="margin-bottom:0"
                (click)="chooseTheme('#262626','#98A1FF')">
                <span class="text_color" [ngClass]="{'text_color_black':invert,'bg_color_light_purple':!invert}"></span>
                <span class="bg_color" [ngClass]="{'text_color_black':!invert,'bg_color_light_purple':invert}"></span>
              </div>
              <span
                [ngClass]="{'color_highlighter': isSelected('#262626','#98A1FF') || isSelected('#98A1FF','#262626')}"></span>
            </div>
            <div id="themeLightBlueWrapper" class="theme-wrapper">
              <div id="themePickerLightBlueBtn" class="theme_picker_button default" style="margin-bottom:0"
                (click)="chooseTheme('#262626','#00C7FD')">
                <span class="text_color" [ngClass]="{'text_color_black':invert,'bg_color_light_blue':!invert}"></span>
                <span class="bg_color" [ngClass]="{'text_color_black':!invert,'bg_color_light_blue':invert}"></span>
              </div>
              <span
                [ngClass]="{'color_highlighter': isSelected('#262626','#00C7FD') || isSelected('#00C7FD','#262626')}"></span>
            </div>
            <div id="themeLightGreenWrapper" class="theme-wrapper">
              <div id="themePickerLightGreenBtn" class="theme_picker_button default" style="margin-bottom:0"
                (click)="chooseTheme('#8BAE46','#262626')">
                <span class="text_color" [ngClass]="{'text_color_light_green':invert,'bg_color_black':!invert}"></span>
                <span class="bg_color" [ngClass]="{'text_color_light_green':!invert,'bg_color_black':invert}"></span>
              </div>
              <span
                [ngClass]="{'color_highlighter': isSelected('#8BAE46','#262626') || isSelected('#262626','#8BAE46')}"></span>
            </div>
          </div>
          <div id="colorPickerFooter" class="card-footer">
            <button type="button" class="btn btn-outline-primary gtmAssetLibraryPageUseDefault"
              (click)="chooseTheme('#ffffff','#0068B5')">
              <span i18n="@@page.theme-picker-footer.use-default">Use Default</span>
            </button>
            <span class="invert_color align-items-end" [ngbTooltip]="invertToolTip"
              (click)="invertColor(pageGrpForm.bcolor,pageGrpForm.bgcolor)"> </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>